import { jsx as _jsx } from "react/jsx-runtime";
import { useQuery } from '@apollo/client';
import { PreviewSkeleton } from './base-components/preview-skeleton';
import { PreviewError } from './base-components/preview-error';
import { SharePreviewDocument } from './graphql/link-preview-share-preview.gql-types';
import { PreviewContent } from './section-components/preview-content';
export const PreviewQuery = ({ onCompleted, onError, url, }) => {
    var _a, _b;
    const { data, loading, refetch } = useQuery(SharePreviewDocument, {
        onCompleted,
        onError,
        variables: { url },
        notifyOnNetworkStatusChange: true,
    });
    if (loading)
        return _jsx(PreviewSkeleton, {});
    if (!((_b = (_a = data === null || data === void 0 ? void 0 : data.viewer) === null || _a === void 0 ? void 0 : _a.linkPreview) === null || _b === void 0 ? void 0 : _b.success))
        return _jsx(PreviewError, { refetch });
    const { description, sourceDomain, title, cachedImageUrl, metadata: { sourceActor } = {}, } = data.viewer.linkPreview.success;
    return (_jsx(PreviewContent, { cachedImageUrl: cachedImageUrl || '',
        description: description || '',
        sourceDomain: sourceDomain || '',
        title: title || '',
        sourceActor: sourceActor || undefined }));
};
//# sourceMappingURL=preview-query.js.map